import { useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { IMPRESSUM_HTML, AGB_HTML, DATENSCHUTZ_HTML } from "@/lib/legalContent";
import "@/styles/legal.css";

const PAGES = {
  impressum: { title: "Impressum", html: IMPRESSUM_HTML, testid: "legal-impressum" },
  agb: { title: "Allgemeine Geschäftsbedingungen", html: AGB_HTML, testid: "legal-agb" },
  datenschutz: { title: "Datenschutzerklärung", html: DATENSCHUTZ_HTML, testid: "legal-datenschutz" },
};

export default function LegalPage({ slug }) {
  const navigate = useNavigate();
  const location = useLocation();
  const cfg = PAGES[slug];

  useEffect(() => { window.scrollTo(0, 0); }, [location.pathname]);

  if (!cfg) return null;

  return (
    <div className="min-h-screen bg-[#09090b] relative overflow-hidden" data-testid={cfg.testid}>
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[300px] bg-cyan-500/5 blur-[120px] rounded-full pointer-events-none" />

      <div className="relative z-10 max-w-3xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-6 -ml-2 text-zinc-400 hover:text-white hover:bg-zinc-800/60"
          data-testid="legal-back-btn"
        >
          <ArrowLeft className="w-4 h-4 mr-2" /> Zurück
        </Button>

        <h1
          className="text-3xl sm:text-4xl font-bold tracking-tight mb-8 text-white"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          {cfg.title}
        </h1>

        <article
          className="legal-content"
          dangerouslySetInnerHTML={{ __html: cfg.html }}
          data-testid="legal-content"
        />
      </div>
    </div>
  );
}
